import { render } from "./DanishAccountInputs.vue?vue&type=template&id=ba466c6c"
import script from "./DanishAccountInputs.vue?vue&type=script&lang=js"
export * from "./DanishAccountInputs.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__